import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useCreateUser } from "@/entities/user";
import { useNavigateToRessource } from "@/hooks/useNavigateToRessource";
import { getModelLink } from "@/modules/model";

import UserForm from "./UserForm";

const Create = ({ model }) => {
  const { t } = useTranslation();

  const mutation = useCreateUser();

  const saveButtonLabel = t("global:add");
  const initialValues = {
    name: "",
    email: "",
    organization_id: model?.organization_id,
    role: "",
  };

  const onNavigateToUser = useNavigateToRessource(
    `${getModelLink("user")}/{{id}}`,
    (response) => response.data.data.id
  );

  return (
    <UserForm
      model={model}
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
      onMutate={onNavigateToUser}
    />
  );
};

Create.propTypes = {
  model: PropTypes.object,
};

export default Create;
